import { render, staticRenderFns } from "./RiskScore.vue?vue&type=template&id=46286947&scoped=true&"
import script from "./RiskScore.vue?vue&type=script&lang=js&"
export * from "./RiskScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46286947",
  null
  
)

export default component.exports